import { _ as r } from "../internals/export.js";
import { i as a } from "../internals/is-array.js";
r({
  target: "Array",
  stat: !0
}, {
  isArray: a
});